module.exports = __webpack_public_path__ + "img/start_bg.2f547b13.png";